import Logo from "../../Logo";
import MenuLink from "../MenuLink";
import MobileMenu from "./MobileMenu";
import "./Burger.scss";
import { useTranslation } from "react-i18next";

const Burger = ({ openBurger, closeBurger }: any) => {
  const { t } = useTranslation("header", { useSuspense: false });
  return (
    <nav
      className="Burger-Nav"
      style={{ display: openBurger === true ? "inline" : "none" }}
    >
      <div className="Burger-Nav-Box">
        <div className="Burger-Menu-Title">
          <div className="Burger-Menu-Logo">
            <Logo type="Desktop" />
          </div>
        </div>
        <ul className="Burger-Menu">
          <h2 className="Burger-Menu-Sub-Title">{t("navigacija")}</h2>
          <MenuLink action={closeBurger} />
          <h2 className="Burger-Menu-Sub-Title">{t("proizvodi")}</h2>
          <MobileMenu action={closeBurger} />
        </ul>
      </div>
    </nav>
  );
};
export default Burger;
